import { render, staticRenderFns } from "./CanvasPage.vue?vue&type=template&id=87b01f38"
import script from "./CanvasPage.vue?vue&type=script&lang=js"
export * from "./CanvasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports